import {
    FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS,
    FCL_EXPORT_BOOKING_REPORT_LIST,
    FCL_EXPORT_BOOKING_REPORT_SUMMARY,
    FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST,
    FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS,
    FCL_EXPORT_SALESPERSON_REPORT_LIST,
    FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS,
    FCL_EXPORT_SALESPERSON_REPORT_SUMMARY,
    FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_LIST,
    FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_SUMMARY,
    FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_CONTAINER_TEUS,
    FCL_EXPORT_DOC_CO_ALERT_REPORT_LIST,
    FCL_EXPORT_TOP_FIFTY_CUSTOMERS_REPORT_LIST,
    FCL_EXPORT_AUTO_CUT_OFF_ALERT_REPORT_LIST,
    FCL_EXPORT_RATE_QUOTE_REPORT_LIST,
    FCL_EXPORT_RATE_QUOTE_REPORT_NOT_BOOKED_EMAIL_LIST,
    FCL_EXPORT_RATE_QUOTE_REPORT_SUMMARY,
    FCL_EXPORT_RATE_QUOTE_REPORT_STATUS_COUNTS,
    FCL_EXPORT_RATE_QUOTE_REPORT_TREND,
    FCL_EXPORT_RATE_QUOTE_REPORT_SALES_PERSON_SUMMARY,
    FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_SUMMARY,
    FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_NOT_BOOKED_SUMMARY,
    FCL_EXPORT_TOP_FIFTY_SUMMARY_REPORT_LIST,
    FCL_EXPPRT_ONBOARD_STATUS_ADUIT_REPORT_LIST,
    FCL_EXPORT_MBL_PROOFING_REPORT,
    FCL_EXPORT_ADVANCED_STATUS_REPORT,
    FCL_EXPORT_TASK_AUDIT_REPORT,
    FCL_EXPORT_TASK_AUDIT_ARRIVAL_POD_PRE_ALERT_REPORT,
    FCL_EXPORT_DAILY_SALES_PERSON_REPORT_LIST,
    FCL_EXPORT_TUES_REPORT_LIST,
    FCL_EXPORT_ONBOARD_REPORT,
    FCL_EXPORT_ACTIVA_REPORT,
    FCL_EXPORT_DAILY_REPORT,
    FCL_EXPORT_PROFIT_AND_LOSS_REPORT,
    FCL_EXPORT_ITALY_VESSEL_REPORT,
    FCL_EXPORT_CUSTOMER_LOSS_REPORT_LIST,
} from "./constant";

export const initStateFeed = {
    exportBookingReportList: [],
    exportBookingReportSummary: {},
    exportBookingReportContainerTeus: [],
    exportSalespersonReportList: [],
    exportSalespersonReportSummary: {},
    exportSalespersonReportContainerTeus: [],
    exportSalespersonReportSalesPersonTeus: [],
    exportSalespersonReportContactList: [],
    exportDestinationCountryWiseTEUSReportList: [],
    exportDestinationCountryWiseTEUSReportSummary: {},
    exportDestinationCountryWiseTEUSReportContainerTeus: [],
    exportDocCoAlertReportList: [],
    exportTopFiftyCustomersReportList: [],
    exportAutoCutOffAlertReportList: [],
    exportTopFiftySummaryReportList: {},

    exportRateQuoteReportList: [],
    exportRateQuoteReportNotBookedEmailList: [],
    exportRateQuoteReportSummary: {},
    exportRateQuoteReportStatusCounts: { Booked: 0, Pending: 0, Expired: 0, Rejected: 0 },
    exportRateQuoteReportTrend: [],
    exportRateQuoteReportSalesPersonSummary: [],
    exportRateQuoteReportCustomerSummary: [],
    exportRateQuoteReportCustomerNotBookedSummary: [],
    exportOnboardStatusReport: [],
    exportMBLProofingReport: [],
    exportAdvancedStatusReport: [],
    exportTaskAuditReport: [],
    exportTaskAuditArrivalPodPreAlertReport: [],
    exportDailySalesPersonReportList: [],
    exportTUESReportList: [],
    exportOnboardReport: [],
    exportActivaReport: [],
    exportDailyReport: [],
    exportProfitAndLossReport: {
        summary: { report1: {}, report2: {} },
        salesPersonSummary: { report1: [], report2: [] },
        bookingDetails: [],
    },
    exportItalyVesselReport: {
        report: [],
        containers: [],
        summary: { totalBooking: 0, totalProfit: 0 },
    },
    exportCustomerLossReportList: [],
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case FCL_EXPORT_BOOKING_REPORT_LIST:
            return {
                ...state,
                exportBookingReportList: action.payload,
            };
        case FCL_EXPORT_BOOKING_REPORT_SUMMARY:
            return {
                ...state,
                exportBookingReportSummary: action.payload,
            };
        case FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS:
            return {
                ...state,
                exportBookingReportContainerTeus: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_LIST:
            return {
                ...state,
                exportSalespersonReportList: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_SUMMARY:
            return {
                ...state,
                exportSalespersonReportSummary: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS:
            return {
                ...state,
                exportSalespersonReportContainerTeus: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS:
            return {
                ...state,
                exportSalespersonReportSalesPersonTeus: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST:
            return {
                ...state,
                exportSalespersonReportContactList: action.payload,
            };

        case FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_LIST:
            return {
                ...state,
                exportDestinationCountryWiseTEUSReportList: action.payload,
            }

        case FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_SUMMARY:
            return {
                ...state,
                exportDestinationCountryWiseTEUSReportSummary: action.payload,
            }

        case FCL_EXPORT_DESTINATION_COUNTRY_WISE_TEUS_REPORT_CONTAINER_TEUS:
            return {
                ...state,
                exportDestinationCountryWiseTEUSReportContainerTeus: action.payload,
            }

        case FCL_EXPORT_DOC_CO_ALERT_REPORT_LIST:
            return {
                ...state,
                exportDocCoAlertReportList: action.payload,
            }

        case FCL_EXPORT_TOP_FIFTY_CUSTOMERS_REPORT_LIST:
            return {
                ...state,
                exportTopFiftyCustomersReportList: action.payload,
            }
        case FCL_EXPORT_TOP_FIFTY_SUMMARY_REPORT_LIST:
            return {
                ...state,
                exportTopFiftySummaryReportList: action.payload,
            }
        case FCL_EXPORT_AUTO_CUT_OFF_ALERT_REPORT_LIST:
            return {
                ...state,
                exportAutoCutOffAlertReportList: action.payload,
            }


        case FCL_EXPORT_RATE_QUOTE_REPORT_LIST:
            return {
                ...state,
                exportRateQuoteReportList: action.payload,
            };

        case FCL_EXPORT_RATE_QUOTE_REPORT_NOT_BOOKED_EMAIL_LIST:
            return {
                ...state,
                exportRateQuoteReportNotBookedEmailList: action.payload,
            };

        case FCL_EXPORT_RATE_QUOTE_REPORT_SUMMARY:
            return {
                ...state,
                exportRateQuoteReportSummary: action.payload,
            };

        case FCL_EXPORT_RATE_QUOTE_REPORT_STATUS_COUNTS:
            return {
                ...state,
                exportRateQuoteReportStatusCounts: action.payload,
            };

        case FCL_EXPORT_RATE_QUOTE_REPORT_TREND:
            return {
                ...state,
                exportRateQuoteReportTrend: action.payload,
            };

        case FCL_EXPORT_RATE_QUOTE_REPORT_SALES_PERSON_SUMMARY:
            return {
                ...state,
                exportRateQuoteReportSalesPersonSummary: action.payload,
            };

        case FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_SUMMARY:
            return {
                ...state,
                exportRateQuoteReportCustomerSummary: action.payload,
            };

        case FCL_EXPORT_RATE_QUOTE_REPORT_CUSTOMER_NOT_BOOKED_SUMMARY:
            return {
                ...state,
                exportRateQuoteReportCustomerNotBookedSummary: action.payload,
            };

        case FCL_EXPPRT_ONBOARD_STATUS_ADUIT_REPORT_LIST:
            return {
                ...state,
                exportOnboardStatusReport: action.payload,
            }

        case FCL_EXPORT_MBL_PROOFING_REPORT:
            return {
                ...state,
                exportMBLProofingReport: action.payload,
            }

        case FCL_EXPORT_ADVANCED_STATUS_REPORT:
            return {
                ...state,
                exportAdvancedStatusReport: action.payload,
            }
        case FCL_EXPORT_TASK_AUDIT_REPORT:
            return {
                ...state,
                exportTaskAuditReport: action.payload,

            }
        case FCL_EXPORT_TASK_AUDIT_ARRIVAL_POD_PRE_ALERT_REPORT:
            return {
                ...state,
                exportTaskAuditArrivalPodPreAlertReport: action.payload,

            }
        case FCL_EXPORT_DAILY_SALES_PERSON_REPORT_LIST:
            return {
                ...state,
                exportDailySalesPersonReportList: action.payload,
            }
        case FCL_EXPORT_TUES_REPORT_LIST:
            return {
                ...state,
                exportTUESReportList: action.payload,
            }

        case FCL_EXPORT_ONBOARD_REPORT:
            return {
                ...state,
                exportOnboardReport: action.payload,
            }

        case FCL_EXPORT_ACTIVA_REPORT:
            return {
                ...state,
                exportActivaReport: action.payload,
            }

        case FCL_EXPORT_DAILY_REPORT:
            return {
                ...state,
                exportDailyReport: action.payload
            }
        case FCL_EXPORT_PROFIT_AND_LOSS_REPORT:
            return {
                ...state,
                exportProfitAndLossReport: action.payload,
            }
        case FCL_EXPORT_ITALY_VESSEL_REPORT:
            return {
                ...state,
                exportItalyVesselReport: action.payload,
            }
        case FCL_EXPORT_CUSTOMER_LOSS_REPORT_LIST:
            return {
                ...state,
                exportCustomerLossReportList: action.payload,
            }
        default:
            return state;
    }
};
